import progressionData from '../data/progressions.json';
import exercisesData from '../data/exercises.json';

// Get progression data for a specific exercise
export const getExerciseProgressions = (exerciseId) => {
  const relationships = progressionData.exerciseRelationships[exerciseId];
  if (!relationships) return null;

  return {
    easierAlternatives: relationships.easierAlternatives?.map(id => 
      exercisesData.find(ex => ex.id === id)
    ).filter(Boolean) || [],
    harderProgressions: relationships.harderProgressions?.map(id => 
      exercisesData.find(ex => ex.id === id)
    ).filter(Boolean) || [],
    variations: relationships.variations?.map(id => 
      exercisesData.find(ex => ex.id === id)
    ).filter(Boolean) || []
  };
};

// Get all exercises in a progression group
export const getProgressionGroup = (groupId) => {
  return progressionData.progressionGroups[groupId];
};

// Find which progression group an exercise belongs to
export const getExerciseProgressionGroup = (exerciseId) => {
  for (const [groupId, group] of Object.entries(progressionData.progressionGroups)) {
    const exercise = group.exercises.find(ex => ex.id === exerciseId);
    if (exercise) {
      return {
        groupId,
        group,
        exercise
      };
    }
  }
  return null;
};

// Get recommended progressions based on user level
export const getRecommendedProgressions = (exerciseId, userLevel = 'intermediate') => {
  const progressions = getExerciseProgressions(exerciseId);
  if (!progressions) return null;

  const levelMap = {
    'beginner': 1,
    'intermediate': 2,
    'advanced': 3
  };

  const userLevelNum = levelMap[userLevel] || 2;

  return {
    easier: progressions.easierAlternatives.filter(ex => 
      ex.level === 'beginner' || (ex.level === 'intermediate' && userLevelNum <= 2)
    ),
    harder: progressions.harderProgressions.filter(ex => 
      ex.level === 'advanced' || (ex.level === 'intermediate' && userLevelNum >= 2)
    ),
    variations: progressions.variations
  };
};

// Check if an exercise has progression data
export const hasProgressionData = (exerciseId) => {
  const hasData = !!progressionData.exerciseRelationships[exerciseId];
  return hasData;
};

// Get progression statistics
export const getProgressionStats = () => {
  const totalExercises = exercisesData.length;
  const exercisesWithProgressions = Object.keys(progressionData.exerciseRelationships).length;
  const progressionGroups = Object.keys(progressionData.progressionGroups).length;

  return {
    totalExercises,
    exercisesWithProgressions,
    progressionGroups,
    coverage: Math.round((exercisesWithProgressions / totalExercises) * 100)
  };
};

// Debug function to log all progression data
export const debugProgressionData = () => {
  console.log('[Progression Debug] Full progression data:', progressionData);
  console.log('[Progression Debug] Exercise relationships:', progressionData.exerciseRelationships);
  console.log('[Progression Debug] Progression groups:', progressionData.progressionGroups);
};
